import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	findAll (params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/payment/members', {params: params}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	/**
	 * @param {number} id
	 * @param {object} data
	 */
	create (id, data) {
		return new Promise(function (resolve, reject) {
			Vue.http.post(store.state.apiURL + '/v1/payment/members', {
				payment_id: id,
				first_name: data.firstName,
				last_name: data.lastName,
				middle_name: data.middleName,
				packet_type: data.packetType,
				phone: data.phone,
				email: data.email
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	/**
	 * @param {number} id
	 * @param {object} data
	 */
	update (id, data) {
		return new Promise(function (resolve, reject) {
			Vue.http.put(store.state.apiURL + '/v1/payment/members/' + id, {
				first_name: data.firstName,
				last_name: data.lastName,
				middle_name: data.middleName,
				packet_type: data.packetType,
				phone: data.phone,
				email: data.email
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	/**
	 * @param {number} id
	 */
	delete (id) {
		return new Promise(function (resolve, reject) {
			Vue.http.delete(store.state.apiURL + '/v1/payment/members/' + id, {}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/payment/member.js